function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bulb"
}, /*#__PURE__*/React.createElement("path", {
  id: "bulb_body",
  fill: "#FFFFFF",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M138,86.465 c0-22.284-18.131-40.348-40.5-40.348c-22.367,0-40.5,18.064-40.5,40.348c0,13.2,6.363,24.918,16.201,32.279v12.91 c0,1.781,1.449,3.229,3.238,3.229h42.12c1.789,0,3.24-1.445,3.24-3.229v-12.91C131.637,111.384,138,99.665,138,86.465z"
}), /*#__PURE__*/React.createElement("g", {
  id: "sockel"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M119.013,139.598 c0,1.803-1.468,3.266-3.276,3.266H79.689c-1.81,0-3.276-1.463-3.276-3.266l0,0c0-1.805,1.468-3.267,3.276-3.267h36.046 C117.545,136.331,119.013,137.793,119.013,139.598L119.013,139.598z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M119.013,146.128 c0,1.804-1.468,3.267-3.276,3.267H79.689c-1.81,0-3.276-1.463-3.276-3.267l0,0c0-1.804,1.468-3.267,3.276-3.267h36.046 C117.545,142.861,119.013,144.324,119.013,146.128L119.013,146.128z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M119.013,152.659 c0,1.804-1.468,3.267-3.276,3.267H79.689c-1.81,0-3.276-1.463-3.276-3.267l0,0c0-1.804,1.468-3.267,3.276-3.267h36.046 C117.545,149.395,119.013,150.855,119.013,152.659L119.013,152.659z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M119.013,159.191 c0,1.803-1.468,3.266-3.276,3.266H79.689c-1.81,0-3.276-1.463-3.276-3.266l0,0c0-1.805,1.468-3.267,3.276-3.267h36.046 C117.545,155.926,119.013,157.389,119.013,159.191L119.013,159.191z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M89.111,168.988c0,4.093,3.851,7.41,8.602,7.41 c4.75,0,8.603-3.317,8.603-7.41"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M81.116,162.457v3.266 c0,1.805,1.467,3.267,3.275,3.267h4.72h17.203h4.293c1.809,0,3.275-1.464,3.275-3.267v-3.266"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M75,89.781v2.427v6.953 l13,12.769v22.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M107,134.68v-22.75 l13-12.769v-6.953v-2.427"
}), /*#__PURE__*/React.createElement("path", {
  id: "glow",
  fill: "none",
  stroke: "#3D3D3D",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  d: "M120,89.802 c0,3.003-2.52,5.438-5.625,5.438c-3.107,0-5.625-2.435-5.625-5.438c0,3.003-2.52,5.438-5.625,5.438 c-3.107,0-5.625-2.435-5.625-5.438c0,3.003-2.519,5.438-5.625,5.438s-5.625-2.435-5.625-5.438c0,3.003-2.519,5.438-5.625,5.438 c-3.105,0-5.625-2.435-5.625-5.438"
}));

var _ref3 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  x1: 151.088,
  y1: 90.5,
  x2: 170,
  y2: 90.5
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  x1: 25,
  y1: 90.5,
  x2: 43.912,
  y2: 90.5
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  x1: 135.392,
  y1: 128.327,
  x2: 148.765,
  y2: 141.677
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  x1: 46.234,
  y1: 39.322,
  x2: 59.607,
  y2: 52.673
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeOpacity: 0,
  x1: 97.5,
  y1: 143.996,
  x2: 97.5,
  y2: 162.876
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  x1: 97.5,
  y1: 18.124,
  x2: 97.5,
  y2: 37.004
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  x1: 59.607,
  y1: 128.327,
  x2: 46.234,
  y2: 141.677
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FBD323",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  x1: 148.765,
  y1: 39.322,
  x2: 135.392,
  y2: 52.672
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bulb-svg",
    x: "0px",
    y: "0px",
    width: "196px",
    height: "196px",
    viewBox: "0 0 196 196",
    enableBackground: "new 0 0 196 196",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "licht",
    style: {
      opacity: 0
    }
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c8c2b760.svg";
export { ForwardRef as ReactComponent };